/* SMA quick buy — opens the theme's built-in quick-buy drawer (variant picker)
 * for multi-variant products on custom product cards.
 *
 * Usage: any element with data-sma-quick-buy="<product-handle>".
 * Drawer content comes from templates/product.sma-quick-buy.json (main-product),
 * so it works even for products assigned to custom PDP templates.
 * After a successful add, the quick-buy drawer closes and the cart drawer opens.
 */
(function () {
  if (window.SMAQuickBuy) return;

  var drawers = {};

  function fallback(handle) {
    window.location.href = '/products/' + handle;
  }

  function open(handle, trigger) {
    if (!handle) return;
    if (!window.customElements || !window.customElements.get('quick-buy-drawer')) {
      fallback(handle);
      return;
    }

    var drawer = drawers[handle];
    if (!drawer || !drawer.isConnected) {
      drawer = document.createElement('quick-buy-drawer');
      drawer.id = 'sma-quick-buy-' + handle;
      drawer.setAttribute('handle', handle + '?view=sma-quick-buy');
      drawer.setAttribute('header-bordered', '');
      drawer.setAttribute('open-from', 'bottom');
      drawer.setAttribute('role', 'region');
      drawer.setAttribute('aria-live', 'polite');
      drawer.setAttribute('data-sma-quick-buy-drawer', '');
      drawer.className = 'quick-buy-drawer drawer';
      document.body.appendChild(drawer);
      drawers[handle] = drawer;
    }

    if (trigger) {
      trigger.setAttribute('aria-busy', 'true');
      trigger.disabled = true;
    }

    var done = function () {
      if (trigger) {
        trigger.removeAttribute('aria-busy');
        trigger.disabled = false;
      }
    };

    // Triggered from the cart drawer (recommendations): close it first so its focus trap /
    // outside-click handling doesn't fight the quick-buy drawer. It re-opens after the add.
    var cartDrawer = trigger && trigger.closest && trigger.closest('#cart-drawer');

    Promise.resolve(cartDrawer && cartDrawer.open ? cartDrawer.hide() : null)
      .then(function () { return drawer.show(); })
      .then(done)
      .catch(function () {
        done();
        if (drawer.isConnected) drawer.remove();
        delete drawers[handle];
        fallback(handle);
      });
  }

  // Card buttons
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-sma-quick-buy]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    open(btn.getAttribute('data-sma-quick-buy'), btn);
  });

  // Item added from one of our quick-buy drawers → close it and open the cart drawer
  document.addEventListener('variant:add', function (e) {
    var path = e.composedPath ? e.composedPath() : [];
    var drawer = null;
    for (var i = 0; i < path.length; i++) {
      if (path[i].hasAttribute && path[i].hasAttribute('data-sma-quick-buy-drawer')) {
        drawer = path[i];
        break;
      }
    }
    if (!drawer) return;

    var cartDrawer = document.getElementById('cart-drawer');
    Promise.resolve(drawer.hide()).then(function () {
      if (cartDrawer && typeof cartDrawer.show === 'function') cartDrawer.show();
    });
  });

  window.SMAQuickBuy = { open: open };
})();
